import { combineReducers } from 'redux'
import settings from './settings/reducer'
import user_summary from './summary/reducer'
import rollover from './rollover/reducer' 
import { thisyear } from './thisyear/reducer'
import { futurechoices } from './futurechoices/reducer'

export const bmc = combineReducers({
	user_summary,
	thisyear,
	futurechoices,
	settings,
	rollover
})